import { swap } from '.';
/**
 * @desc Left field from client enum, right - from server enum.
 *
 * @example
 * const adBlockTypeMap = createDataRecordConverter({
 * 	[ClientAdBlockType.AdBlock]: AdBlockType.Adblock,
 * 	[ClientAdBlockType.PartnerAdBlock]: AdBlockType.Partneradblock,
 * 	[ClientAdBlockType.IntegratedEventsBlock]: AdBlockType.Integratedeventsblock,
 * });
 *
 * export const convertToServerAdBlockType = (adBlockType: ClientAdBlockType): AdBlockType => {
 * 	return adBlockTypeMap.toServer[adBlockType];
 * };
 *
 * export const convertToClientAdBlockType = (adBlockType: AdBlockType): ClientAdBlockType => {
 * 	return adBlockTypeMap.toClient[adBlockType];
 * };
 */
export var createDataRecordConverter = function (serverData) {
    var reversed = swap(serverData);
    return {
        toClient: reversed,
        toServer: serverData,
    };
};
